import React, { useState, useEffect } from 'react';
import { Container, Typography, CircularProgress } from '@mui/material';
import Presentacion from './Cliente/Presentacion';
import Item from './Cliente/Item';
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from './auth/UsersConfig/Authfirebase';
import './Home.css';
import { ConvertObjToArray } from './Tools/Converts';
import Categoria from './Cliente/Categoria';

function Home() {
  const [datproductsOferta, setDatproductsOferta] = useState([]);
  const [datproducts, setDatproducts] = useState([]);
  const [categoria, setCategoria] = useState([]);
  const [loading, setLoading] = useState(true);

  const slides = [
    {
      imgSrc: process.env.PUBLIC_URL + "/presentacion/img1.jpg",
      title: "Navidad",
      description: "Todo para su navidad perfecta"
    },
    {
      imgSrc: process.env.PUBLIC_URL + "/presentacion/img2.jpg",
      title: "Regalos",
      description: "Encuentra los mejoras regalos"
    },
    {
      imgSrc: process.env.PUBLIC_URL + "/presentacion/img3.jpg",
      title: "familia",
      description: "Regalos para toda la familia"
    }
  ];

  const GetAllproducts = async () => {
    try {
      const Myproducts = collection(db, "products");
      const Query = query(Myproducts, where("Activo", "==", true), where("quantity", ">", 0));
      const Data = await getDocs(Query);

      const data = Data.docs.map(doc => ({
        id: doc.id,
        nombre: doc.data().nombre,
        desc: doc.data().desc,
        price: doc.data().price,
        co_price: doc.data().comparePrice,
        Img: doc.data().Img
      }));

      const dataOferta = data.filter(item => item.co_price > 0);
      const dataNormal = data.filter(item => item.co_price === 0);

      setDatproductsOferta(dataOferta);
      setDatproducts(dataNormal);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  const GetWhereCategoria = async () => {
    try {
      const collectRef = collection(db, "Catalogos");
      const queryRef = query(collectRef, where('Activo', '==', true), where('NoList', '==', 2));
      const snapshot = await getDocs(queryRef);

      let datList = [];
      snapshot.docs.forEach((doc) => {
        datList = ConvertObjToArray(doc.data().List);
      });

      setCategoria(datList);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setCategoria([]);
    }
  };

  useEffect(() => {
    GetAllproducts();
    GetWhereCategoria();
  }, []);

  if (loading) {
    return (
      <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <>
      <Presentacion settings={slides} />

      <div className='ContHome'>
        <Typography variant="h5" className='titlehe'>OFERTAS</Typography>
        <div className="containerItems">
          {datproductsOferta.map(product => (
            <Item key={product.id} detalle={product} />
          ))}
        </div>

        <Typography variant="h5" className='titlehe'>PARA TI</Typography>
        <div className="containerItems">
          {datproducts.map(product => (
            <Item key={product.id} detalle={product} />
          ))}
        </div>

        <Typography variant="h5" className='titlehe'>CATEGORÍAS</Typography>
        <div className="containerItems">
          {categoria.map(cat => (
            <Categoria key={cat.id} setting={cat} />
          ))}
        </div>
      </div>
    </>
  );
}

export default Home;
